import { render, staticRenderFns } from "./AccountPreview.vue?vue&type=template&id=15c90fa6"
import script from "./AccountPreview.vue?vue&type=script&lang=js"
export * from "./AccountPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports